// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/causali-contabili/:id',
    requestBody: null,
    response: '{ success: true, data: { ..., righe: [...] }, logs: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/coge/piano-conti?societaId=',
    requestBody: null,
    response: '{ success: true, data: [tree] }'
  },
  {
    method: 'GET',
    endpoint: '/api/sezionali-iva?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, tipo, attivo }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/registri-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, tipo, attivo }] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/causali-contabili/:id',
    requestBody: '{ codice, descrizione, gestisceIva, sezionaleIvaDefaultId, registroContabileDefaultId, note }',
    response: '{ success: true }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/causali-contabili/:id/default',
    requestBody: '{ isDefault }',
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/causali-contabili/:id/righe',
    requestBody: '{ descrizione, segno, origineConto, contoCogeId, formula, percentuale, obbligatoria }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/causali-contabili/:id/righe/:rigaId',
    requestBody: '{ descrizione, segno, origineConto, contoCogeId, formula, percentuale, obbligatoria }',
    response: '{ success: true }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/causali-contabili/:id/righe/:rigaId',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/causali-contabili/:id/righe/riordina',
    requestBody: '{ ordineIds }',
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
